import { ContentCopy } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { copyToClipboard } from 'helpers/general';
import { Shipment } from 'types';

export interface CopyShipmentDevicesCellProps {
    devices: Shipment['devices'];
}

export const CopyShipmentDevicesCell = ({
    devices,
}: CopyShipmentDevicesCellProps) => {
    const handleCopy = (e: React.MouseEvent) => {
        copyToClipboard(e, Object.keys(devices).join(',\n'));
    };

    return (
        <div data-testid="CopyShipmentDevicesCell">
            <Tooltip title="Copy Device Ids">
                <ContentCopy onClick={handleCopy} />
            </Tooltip>
        </div>
    );
};
